import { createSlice } from '@reduxjs/toolkit'

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isEmailVerified: false,
  },
  reducers: {
    setIsEmailVerified(state, action) {
      state.isEmailVerified = action.payload
    },
  },
})

export const { setIsEmailVerified } = userSlice.actions
export default userSlice.reducer
